import ImageWithContent, { ImageWithContentProps, CONTENT_SIDE } from './ImageWithContent'

export default ImageWithContent

export { ImageWithContent, CONTENT_SIDE }
export type { ImageWithContentProps }
